export type HelpFaq = {
  id: string;
  question: string;
  answer: string[];
};

export const HELP_SUPPORT_EMAIL = "info@dataengbytes.com";

export const CLAIM_STEPS_SELF = [
  "Open the confirmation email and tap Open Connect (or go to connect.dataengbytes.com).",
  "Sign in with the same email that is on the ticket. First time: register with that email, then sign in. Magic link, password, and Google all work.",
  "On Home, tap the city you bought — the 2027 city, not a closed 2026 window.",
  "Connect matches your sign-in email to the attendee record and claims automatically. There is no claim code.",
  "Finish the short profile wizard. Opt in if you want to appear in that city’s directory.",
];

export const CLAIM_STEPS_OTHERS = [
  "The buyer email includes per-seat assign links and Manage tickets in Connect.",
  "Each person opens their /assign/… link and saves their name and email. No login is required for that step.",
  "They then sign in to Connect with that attendee email and tap the city to claim.",
  "The buyer can also name seats at connect.dataengbytes.com/tickets after signing in.",
];

export const HELP_FAQS: HelpFaq[] = [
  {
    id: "who-can-use",
    question: "Who can use Connect?",
    answer: [
      "Anyone can create a Connect account. Browsing the directory, sending connections, and scanning badges requires a claimed ticket to any DataEngBytes event.",
      "Login alone is not enough. Your sign-in email must match a ticket (or a seat assigned to you).",
    ],
  },
  {
    id: "who-can-i-see",
    question: "Who can I see in the directory?",
    answer: [
      "People who opted in and set visibility to directory.",
      "In a city’s directory you only see people who also claimed that city. A Melbourne ticket holder can open Brisbane, but will only see Brisbane claimants who opted in.",
      "Your own profile is always visible to you. Hidden or opted-out people do not appear.",
    ],
  },
  {
    id: "email-match",
    question: "Why didn’t my ticket claim?",
    answer: [
      "The usual cause is an email mismatch: you signed in with a different address than the one on the ticket.",
      "Sign out, register or sign in with the ticket email, then tap the city again.",
      "Claim also fails if that city’s Connect window is closed. Melbourne 2026 closed 31 July 2026. 2027 cities are open.",
    ],
  },
  {
    id: "melbourne-2026",
    question: "I went to Melbourne or Sydney 2026. Why isn’t my city on Home?",
    answer: [
      "Home only lists cities whose Connect window is still open, plus any past cities the API still returns.",
      "Melbourne 2026’s window closed 31 July 2026, so it no longer appears. Sydney 2026 stays listed under Past conferences until 31 August 2026.",
      "If you already claimed a 2026 ticket, you can still use Connect: open a 2027 city to browse that city’s opted-in attendees.",
    ],
  },
  {
    id: "new-city",
    question: "I bought another city. Do I claim again?",
    answer: [
      "Yes, if you want to appear in that city’s directory. Claim is per city.",
      "After you have claimed any one city, you can browse other open cities without buying those tickets. You will only see people who claimed the city you opened.",
    ],
  },
  {
    id: "opt-in",
    question: "Does buying a ticket put me in the directory?",
    answer: [
      "No. Purchase creates the ticket. Claim links it to your Connect account. Opt-in + directory visibility makes you visible to other ticket holders.",
      "You can stay hidden and still browse people who opted in.",
    ],
  },
  {
    id: "bought-for-me",
    question: "Someone else bought my ticket. How do I claim?",
    answer: [
      "They should send you the assign link from the confirmation email, or name your seat in Manage tickets.",
      "Save your details on the assign page using the email you will sign in with, then sign in and tap the city.",
    ],
  },
  {
    id: "scan",
    question: "When can I scan badges?",
    answer: [
      "Scan and sponsor leads stay tied to that city’s live Connect window. They are not available after the window closes.",
      "You must have claimed a ticket. Non-sponsors have a small per-city scan quota; sponsor reps do not.",
    ],
  },
];
